import { extend, ResponseError } from 'umi-request';
import { message } from 'iglooform';
import errorCode from './errorCode';
import vi from '@/locales/vi-VN';
import en from '@/locales/en-US';
import { request as umiReqeust } from 'umi';

export let reqeust = umiReqeust;

export const errorHandler = async (error: ResponseError) => {
  const { response } = error;

  const locale: { [key: string]: any } = {
    'vi-VN': vi,
    'en-US': en,
  };

  const currentLang = localStorage.getItem(SELECTED_LANG) || 'vi-VN';

  let rst: any;
  if (response && response.status) {
    const { status } = response;

    try {
      rst = await response.json();
    } catch {
      rst = null;
      console.log('non-json response');
    }

    if (status === 401 || (rst && rst.message === 'invalid jwt string')) {
      localStorage.removeItem(TOKEN_NAME);
      window.location.href = `${window.location.protocol}//${window.location.host}/login`;
    }

    if (status === 500 && rst?.message) {
      message.error(rst?.message);
      return;
    }
  }

  const { code } = rst;
  const erroeMessage = rst?.error?.split(':').pop();
  const codeMsg = errorCode[code]?.id || '';
  if (rst.message === 'invalid jwt string') {
    return;
  }
  message.error(
    locale[currentLang][codeMsg] ||
      erroeMessage ||
      rst?.message ||
      rst?.msg ||
      'No response from server.',
  );

  throw error;
};

const currentLang = (localStorage.getItem(SELECTED_LANG) as string) || 'vi-VN';

const request = extend({
  prefix: API_URL,
  headers: {
    'Accept-Language': currentLang,
    platform: 'agency-platform',
    'X-Axinan-Authorization': `Bearer ${
      localStorage.getItem(TOKEN_NAME) as string
    }`,
  },
  errorHandler,
});

export const updateRequest = (currentLang: string) => {
  request.extendOptions({
    prefix: API_URL,
    headers: {
      platform: 'agency-platform',
      'X-Axinan-Authorization': `Bearer ${
        localStorage.getItem(TOKEN_NAME) as string
      }`,
      'Accept-Language': currentLang, // 更新当前语言作为请求头
    },
    timeout: 30000,
    errorHandler,
  });
};

export default request;
